// extracted by mini-css-extract-plugin
export var section = "_2w-1";
export var topNav = "_2w-0";